import React from 'react';
import _ from 'lodash';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import NcVehicleRegistrationService from '../../../../../service/NcVehicleRegistrationService';
import NcCPAHSModal from './NcCPAHSModal';

export default class NcCPAHS extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      headers: [],
    };

    this.comboFields = [
      {
        value: 'externalBillId',
        display: 'External Bill Id',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'transactionId',
        display: 'Transaction Id',
      },
    ];
  }

  onPayableSelect(row) {
    const { rows = [], } = this.state;
    const selectedPayable = rows.find(order => order.raw.id === row.id);
    this.setState({
      selectedPayable: selectedPayable.raw,
    });
  }

  getPayables(event) {
    const { search, combo, } = event;
    this.reset();

    const vm = this;
    const headers = [];
    const rows = [];
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = 'ncdmv_civil_penalty_license_and_theft';

    const allowedKeys = [
      'id',
      'externalBillId',
      'customerId',
      'paymentAmount',
      'paymentTransactionId',
      'paymentDate',
    ];

    NcVehicleRegistrationService.getPayablesBySearchCriteria(criteria)
      .then((response) => {
        const { payables, } = response.data;
        if (payables.length > 0) {
          allowedKeys.forEach((allowedKey) => {
            headers.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
          payables.forEach((payable) => {
            const filtered = _.pick(payable, allowedKeys);
            rows.push({
              value: Object.values(filtered),
              raw: payable,
            });
          });
        }
        vm.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay = (payable) => {
    if (!payable) {
      return null;
    }

    return (
      <div>
        <p>{`Selected ID: ${payable.id}`}</p>
        <hr />
        <NcCPAHSModal selectedPayable={payable} />
      </div>
    );
  };

  reset() {
    this.setState({
      rows: [],
      headers: [],
      selectedPayable: null,
    });
  }

  render() {
    const {
      headers = [],
      rows = [],
      selectedPayable,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.getPayables(data)}
        />
        <div style={{ marginTop: '50px', }}>
            <FieldSet title="CP AHS Payables">
            <Grid
              headers={headers}
              rows={rows}
              style={{ maxHeight: '800px', overflowY: 'auto', }}
              onRowSelect={data => this.onPayableSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedPayable)}
        </div>
      </div>
    );
  }
}
